import axios from 'axios';
import { getToken } from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';
const client = axios.create({ baseURL: API_BASE });
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) { config.headers = config.headers || {}; config.headers.Authorization = `Bearer ${token}`; }
  return config;
});

export async function listVecinos(params = {}) {
  const { data } = await client.get('/vecinos', { params });
  return data.vecinos || [];
}
export async function createVecino(payload) {
  const { data } = await client.post('/vecinos', payload);
  return data.vecino;
}
export async function getVecino(id) {
  const { data } = await client.get(`/vecinos/${id}`);
  return data;
}
export async function addInteraction(id, payload) {
  const { data } = await client.post(`/vecinos/${id}/interactions`, payload);
  return data.interaccion;
}
export async function notifyVecino(id, payload) {
  const { data } = await client.post(`/vecinos/${id}/notify`, payload);
  return data;
}
